<template>
  <div>
    <q-card class="my-card">
      <q-card-section>
        <div class="row">
          <div class="col-7 container-excepciones">
            <div class="row title-row">
              <div class="title">
                Excepciones datos de Servicio por {{ tituloRelacion }}
              </div>
            </div>
            <div class="row title-row">
              <div class="subtitle">{{ tituloServicio }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <q-select
              :data-cy="`select-${this.datacy}`"
              outlined
              use-input
              clearable
              hide-selected
              fill-input
              v-model="relacionSelected"
              :options="relacionOptions"
              input-debounce="0"
              @filter="filterFnRelacion"
              option-value="id"
              option-label="name"
              :label="this.tituloRelacion"
              class="col-5"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    Sin resultados
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>

          <div class="col-6">
            <q-select
              :data-cy="`select-aplicacion-asignada-${this.datacy}`"
              outlined
              use-input
              clearable
              hide-selected
              fill-input
              v-model="aplicacionAsignadaSelected"
              :options="aplicacionAsignadaOptions"
              input-debounce="0"
              @filter="filterFnAplicacion"
              option-value="id"
              option-label="name"
              label="Aplicación asignada"
              class="col-5"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    Sin resultados
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
        </div>

        <div class="row">
          <q-btn
            class="btnAddExcepcion"
            :data-cy="`add-excepcion-${this.datacy}`"
            style="margin-left: 0 !important"
            color="primary"
            label="AÑADIR EXCEPCIÓN"
            icon="add"
            :disable="!disabledButton"
            @click="addExcepcion()"
          />
        </div>

        <div class="row title-row">
          <div class="subtitle">Resumen de excepciones</div>
        </div>

        <div class="row">
          <div class="col-12">
            <ListadoExcepciones
              :filterField = "this.filterField"
              :tituloRelacion="this.tituloRelacion"
              :dataExcepciones="excepciones"
              :isLoading="isLoadingExcepciones"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import { QCard } from 'quasar';
import ListadoExcepciones from '../components/ListadoExcepciones.vue';
import Loading from '@/components/shared/mixins/Loading.js';
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import Utils from '@/components/shared/helpers/Utils.js';

export default {
  components: {
    QCard,
    ListadoExcepciones
  },
  mixins: [Message, Validation, Loading],
  props: {
    datacy: String,
    filterField: String,
    filterFieldId: String,
    tituloRelacion: String,
    relaciones: Array,
    aplicacionesAsignadas: Array,
    tituloServicio: String,
    eventSaveExcepcion: { type: String, required: false }
  },
  data () {
    return {
      relacionSelected: null,
      relacionOptions: this.relaciones,
      aplicacionAsignadaSelected: null,
      aplicacionAsignadaOptions: this.aplicacionesAsignadas,
      excepciones: [],
      isLoadingExcepciones: false
    };
  },
  mounted () {
    this.$eventHub.$on(
      this.eventSaveExcepcion,
      ({ callback, idServicio }) =>
        this.saveExcepcion(callback, idServicio)
    );
  },
  async created () {
    if (this.$route.params.idServ) {
      await this.getExcepciones();
    }
  },
  beforeDestroy () {
    this.$eventHub.$off(this.eventSaveExcepcion);
  },
  computed: {
    disabledButton () {
      return this.aplicacionAsignadaSelected && this.relacionSelected;
    }
  },
  watch: {
    aplicacionesAsignadas () {
      this.aplicacionAsignadaOptions = this.aplicacionesAsignadas;
    },
    relaciones () {
      this.relacionOptions = this.relaciones;
    }
  },
  methods: {
    async getExcepciones () {
      this.showLoading();

      let request = {
        controller: '/Servicio/' + this.$route.params.idServ + '/Excepciones'
      };
      this.isLoadingExcepciones = true;

      await this.$store
        .dispatch('PF/getSuit', request)
        .then((response) => {
          this.excepciones = response.data.filter(e => e[this.filterField] !== undefined);
          this.hideLoading();
          this.isLoadingExcepciones = false;
        })
        .catch((err) => {
          this.showError(err);
          this.hideLoading();
          this.isLoadingExcepciones = false;
        });
    },
    filterFnRelacion (val, update) {
      update(() => {
        this.relacionOptions = Utils.filterFn(val, this.relaciones);
      });
    },
    filterFnAplicacion (val, update) {
      update(() => {
        this.aplicacionAsignadaOptions = Utils.filterFn(val, this.aplicacionesAsignadas);
      });
    },
    addExcepcion () {
      if (!this.checkExcepcionValida()) {
        this.add();
      }
    },
    checkExcepcionValida () {
      return this.excepciones.find(
        (excepcion) => excepcion[this.filterFieldId] === this.relacionSelected.id
      );
    },
    add () {
      this.excepciones.push({
        aplicacionId: this.aplicacionAsignadaSelected.id,
        aplicacionName: this.aplicacionAsignadaSelected.name,
        [this.filterFieldId]: this.relacionSelected.id,
        [this.filterField]: this.relacionSelected.name
      });
    },
    async saveExcepcion (callback, idServicio = 0) {
      let excepcionesToSave = [];
      if (this.excepciones.length > 0) {
        excepcionesToSave = this.prepareDataToSaveExcepcion();
      }
      await this.save(callback, excepcionesToSave, idServicio);
    },
    prepareDataToSaveExcepcion () {
      let excepcionesToSave = JSON.parse(JSON.stringify(this.excepciones));
      return excepcionesToSave;
    },
    async save (callback, excepciones, idServicio = 0) {
      let idSev = !this.$route.params.idServ
        ? idServicio
        : this.$route.params.idServ;
      let request = {
        controller: '/Servicio/' + idSev + '/excepcion-relationship',
        filter: {},
        body: excepciones
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/postSuit', request)
        .then((response) => {
          this.idServ = response.data.id;
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch((err) => {
          this.showError(err.message);

          responseData = {
            data: null,
            status: false
          };
        });
      callback(responseData);
    }
  }
};
</script>
<style lang="scss" scoped>
.container-excepciones {
  .input-row {
    padding: 16px 0px;
  }
}
.my-card {
  margin-top: 2%;
}
.btnAddExcepcion {
  margin-top: 25px;
}

.subtitle {
  margin: 27px 124px 25px 4px;
  font-size: 16px !important;
  font-weight: bold !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: normal !important;
  letter-spacing: 0.23px !important;
  color: rgba(0, 0, 0, 0.5) !important;
}

.col-6 {
  padding-right: 10px;
}
</style>
